import React, { useState, useCallback, useRef, useEffect } from 'react';
import {
  StyledModal,
  ModalTitle,
  ModalDescription,
  ModalContent,
  FormRow,
  FormField,
  Label,
  Required,
  StyledSelect,
  StyledInput,
  DragDropZone,
  FileInput,
  UploadContent,
  UploadCenter,
  IconWrapper,
  TextWrapper,
  UploadTitle,
  UploadText,
  UploadHint,
  FileDisplay,
  FileItem,
  FileInfo,
  FileName,
  FileSize,
  RemoveButton,
  ButtonGroup,
  CancelButton,
  PrimaryButton,
  ProgressWrapper,
  ProgressBar,
  ProgressFill,
  ProgressSection,
  ProgressHeader,
  ProgressLabel,
  CloudIconWrapper,
  StatusBadge,
  StyledProgress,
  FileHeader,
  FileIconWrapper,
  FileDetails,
} from './HybridMailStyles';
import { Button, Icon, Input, Select, message, Divider } from 'antd';
import { withTranslation } from 'react-i18next';
import { HYBRID_MAIL_ROOM } from './TranslationValue';
import axios from 'axios';
import {
  // uploadFileToBlob,
  // uploadBlock,
  // commitBlockList,
  // createHybridBatch,
  // detectAndSplit,
  createBatchNew,
} from '../../../../utils/services/hybridMailAPI';
import { listofServices } from '../../../../utils/services/storageAPI';
import HybridQueue from './HybridQueue';
import { QueueButton } from '../Styles';

const NAMESPACES = ['HYBRID_MAIL_ROOM', 'INSERT_NAMESPACES', 'HYBRID_MAIL'];
const { Option } = Select;

const SendLettersModal = ({ visible, setHybridModal, setHybridInfo, setCurrentPage, t }) => {
  const [jobName, setJobName] = useState('');
  const [splitCriteria, setSplitCriteria] = useState('address');
  const [pageCount, setPageCount] = useState('1');
  const [uploadedFile, setUploadedFile] = useState(null);
  const [isDragging, setIsDragging] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [isUploading, setIsUploading] = useState(false);
  // const [failedChunkIndex, setFailedChunkIndex] = useState(0);
  // const [accumulatedBlockIds, setAccumulatedBlockIds] = useState([]);
  const [hasUploadError, setHasUploadError] = useState(false);
  // const [activeStorage, setActiveStorage] = useState(null);
  const [showQueue, setShowQueue] = useState(false);
  const cancelTokenSource = useRef(null);
  // const uploadInfoRef = useRef(null);
  const [startAndEndDate, setStartAndEndDate] = useState(null);
  const [createBatch, setCreateBatch] = useState(false);
  const isBatchQueueButtonDisabled = !(jobName?.trim() !== '' && splitCriteria === 'address');
    
  // useEffect(() => {
  //   if (visible) {
  //     const fetchStorageSettings = async () => {
  //       try {
  //         const response = await listofServices();
  //         if (response?.statusCode === 107) {
  //           const configuredService = response.data.services.find(s => s.storageConfigured);
  //           setActiveStorage(configuredService?.name || 'azure');
  //         }
  //       } catch (error) {
  //         console.error('Failed to fetch storage settings:', error);
  //         setActiveStorage('azure'); // Default to azure if fetch fails
  //       }
  //     };
  //     fetchStorageSettings();
  //   }
  // }, [visible]);

  const handleDragOver = useCallback(e => {
    e.preventDefault();
    setIsDragging(true);
  }, []);

  const handleDragLeave = useCallback(e => {
    e.preventDefault();
    setIsDragging(false);
  }, []);

  const handleDrop = useCallback(e => {
    e.preventDefault();
    setIsDragging(false);

    const files = Array.from(e.dataTransfer.files).filter(
      file =>
        file.type === 'application/pdf' ||
        file.type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
    );

    if (files.length > 0) {
      setUploadedFile(files[0]);
      // setFailedChunkIndex(0);
      // setAccumulatedBlockIds([]);
      setHasUploadError(false);
      setUploadProgress(0);
    } else {
      message.error(
        t(HYBRID_MAIL_ROOM.INVALID_FILE_FORMAT.key, HYBRID_MAIL_ROOM.INVALID_FILE_FORMAT.value),
        3,
      );
    }
  }, []);

  const handleFileSelect = useCallback(e => {
    if (e.target.files && e.target.files.length > 0) {
      const file = e.target.files[0];

      if (
        file.type === 'application/pdf' ||
        file.type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' 
      ) {
        setUploadedFile(file);
        // setFailedChunkIndex(0);
        // setAccumulatedBlockIds([]);
        setHasUploadError(false);
        setUploadProgress(0);
      } else {
        message.error(
          t(HYBRID_MAIL_ROOM.INVALID_FILE_FORMAT.key, HYBRID_MAIL_ROOM.INVALID_FILE_FORMAT.value),
          3,
        );
      }
    }
    e.target.value = '';
  }, []);

  const handleSplitCriteriaChange = (criteria) => {
    setSplitCriteria(criteria);
    if(criteria === 'address') {
      setPageCount(1);
    }
  }

  const removeFile = useCallback(() => {
    if (cancelTokenSource.current) {
      cancelTokenSource.current.cancel('Upload cancelled by user.');
      cancelTokenSource.current = null;
    }
    setUploadedFile(null);
    // setFailedChunkIndex(0);
    // setAccumulatedBlockIds([]);
    setHasUploadError(false);
    setUploadProgress(0);
    setIsUploading(false);
  }, []);

  // ---------------------------------------------------------------------------
  // OLD chunked-upload logic (commented out — replaced by createBatchNew below)
  // ---------------------------------------------------------------------------
  // const uploadLargeFileInChunks = async file => {
  //   const fileSize = file.size;
  //   const isSmallFile = fileSize < 5 * 1024 * 1024;
  //   try {
  //     if (cancelTokenSource.current) {
  //       cancelTokenSource.current.cancel('Previous upload cancelled.');
  //     }
  //     cancelTokenSource.current = axios.CancelToken.source();
  //
  //     const params = {
  //       batchName: jobName,
  //       envelopeType: 'C5',
  //       deliveryClass: 'First class',
  //       splitType: splitCriteria,
  //       pageCount: splitCriteria === 'pageCount' ? pageCount : null,
  //       fileName: file.name,
  //     };
  //
  //     setIsUploading(true);
  //
  //     const { data = {}, statusCode } = await createHybridBatch(params);
  //     if (statusCode === 7029 && data && data?.uploadUrl && data?.batchId) {
  //       uploadInfoRef.current = data;
  //     } else {
  //       message.error(
  //         t(
  //           HYBRID_MAIL_ROOM.HYBRID_BATCH_CREATION_FAILED.key,
  //           HYBRID_MAIL_ROOM.HYBRID_BATCH_CREATION_FAILED.value,
  //         ),
  //       );
  //       return;
  //     }
  //     const CHUNK_SIZE = 4 * 1024 * 1024; // 4MB chunks
  //
  //     const sasURI = uploadInfoRef.current?.uploadUrl;
  //
  //     if (isSmallFile) {
  //       const response = await uploadFileToBlob(
  //         sasURI,
  //         file,
  //         cancelTokenSource.current.token,
  //         activeStorage,
  //       );
  //       if (response && response.status >= 200 && response.status < 300) {
  //         setUploadProgress(100);
  //         setHasUploadError(false);
  //       } else {
  //         setHasUploadError(true);
  //         throw new Error('Direct upload failed');
  //       }
  //     } else {
  //       const totalChunks = Math.ceil(fileSize / CHUNK_SIZE);
  //       const blockIds = [...accumulatedBlockIds];
  //
  //       for (let i = failedChunkIndex; i < totalChunks; i++) {
  //         const start = i * CHUNK_SIZE;
  //         const end = Math.min(start + CHUNK_SIZE, fileSize);
  //         const chunk = file.slice(start, end);
  //         const partNumber = i + 1;
  //         const blockId = btoa(`block-${i.toString().padStart(5, '0')}`);
  //
  //         try {
  //           const response = await uploadBlock(
  //             sasURI,
  //             blockId,
  //             chunk,
  //             cancelTokenSource.current.token,
  //             activeStorage,
  //             partNumber,
  //           );
  //           if (response && response.status >= 200 && response.status < 300) {
  //             const identifier = activeStorage === 'aws' ? response.headers.etag : blockId;
  //             blockIds.push(identifier);
  //             setAccumulatedBlockIds([...blockIds]);
  //             setUploadProgress(Math.round(((i + 1) / totalChunks) * 100));
  //           } else {
  //             setFailedChunkIndex(i);
  //             setHasUploadError(true);
  //             throw new Error(`Chunk ${i} upload failed`);
  //           }
  //         } catch (err) {
  //           setFailedChunkIndex(i);
  //           setHasUploadError(true);
  //           throw err;
  //         }
  //       }
  //
  //       const blockListXml =
  //         activeStorage === 'azure'
  //           ? `<?xml version="1.0" encoding="utf-8"?>
  //         <BlockList>
  //         ${blockIds.map(id => `<Latest>${id}</Latest>`).join('')}
  //         </BlockList>`
  //           : null;
  //
  //       const response = await commitBlockList(
  //         sasURI,
  //         blockListXml,
  //         file.type,
  //         cancelTokenSource.current.token,
  //         activeStorage,
  //         blockIds,
  //       );
  //       if (response && response.status >= 200 && response.status < 300) {
  //         setHasUploadError(false);
  //       } else {
  //         setHasUploadError(true);
  //         throw new Error('Commit block list failed');
  //       }
  //     }
  //
  //     if (isSmallFile) {
  //       setTimeout(() => {
  //         detectAndSplit({ batchUUID: uploadInfoRef.current?.batchId });
  //         setHybridModal(false);
  //         setIsUploading(false);
  //         setUploadedFile(null);
  //       }, 1000);
  //     } else {
  //       detectAndSplit({ batchUUID: uploadInfoRef.current?.batchId });
  //       setHybridModal(false);
  //       setUploadedFile(null);
  //     }
  //     setJobName('');
  //     message.success(
  //       t(HYBRID_MAIL_ROOM.FILE_UPLOAD_SUCCESS.key, HYBRID_MAIL_ROOM.FILE_UPLOAD_SUCCESS.value),
  //     );
  //     cancelTokenSource.current = null;
  //   } catch (error) {
  //     if (axios.isCancel(error)) {
  //       console.log('Upload cancelled:', error.message);
  //       return;
  //     }
  //     console.error('File upload failed:', error);
  //     message.error(
  //       t(HYBRID_MAIL_ROOM.FILE_UPLOAD_FAILED.key, HYBRID_MAIL_ROOM.FILE_UPLOAD_FAILED.value),
  //     );
  //   } finally {
  //     !isSmallFile && setIsUploading(false);
  //   }
  // };
  //
  // const handleSubmit = () => {
  //   if (uploadedFile) {
  //     uploadLargeFileInChunks(uploadedFile);
  //   }
  // };
  // ---------------------------------------------------------------------------

  // New upload handler — sends directly to hybrid/createBatchNew (multipart/form-data)
  const handleSubmit = async () => {
    if (!uploadedFile) return;
    try {
      setIsUploading(true);
      setHasUploadError(false);

      const response = await createBatchNew({
        batchName: jobName,
        envelopeType: 'C5',
        deliveryClass: 'First class',
        splitType: splitCriteria,
        pageCount: splitCriteria === 'pageCount' ? pageCount : null,
        file: uploadedFile,
      });

      if (response && response.statusCode === 7002) {
        setUploadProgress(100);
        // Success
        message.success(
          t(HYBRID_MAIL_ROOM.FILE_UPLOAD_SUCCESS.key, HYBRID_MAIL_ROOM.FILE_UPLOAD_SUCCESS.value),
        );
        setTimeout(() => {
          setHybridModal(false);
          setUploadedFile(null);
          setJobName('');
          handleSplitCriteriaChange('address');
          setIsUploading(false);
        }, 1000);
      } else {
        setIsUploading(false);
        setHasUploadError(true);
        message.error(
          t(HYBRID_MAIL_ROOM.FILE_UPLOAD_FAILED.key, HYBRID_MAIL_ROOM.FILE_UPLOAD_FAILED.value),
        );
      }
    } catch (error) {
      console.error('File upload failed:', error);
      setIsUploading(false);
      setHasUploadError(true);
      message.error(
        t(HYBRID_MAIL_ROOM.FILE_UPLOAD_FAILED.key, HYBRID_MAIL_ROOM.FILE_UPLOAD_FAILED.value),
      );
    }
  };

  const enableProceed =
    jobName?.trim() !== '' &&
    splitCriteria?.trim() !== '' &&
    uploadedFile &&
    (splitCriteria === 'address' || (splitCriteria === 'pageCount' && pageCount));

  const closeModals = useCallback((showQueue, showHybrid, batchName = '') => {
    setHybridModal(showHybrid);
    setShowQueue(showQueue);
    !showHybrid && setJobName('');
    showHybrid && setJobName(batchName);
  }, []);

  return (
    <>
    <StyledModal isHybrid={true}
      visible={visible}
      onCancel={() => setHybridModal(false)}
      centered
      closable={true}
      maskClosable={false}
      footer={null}
      width="550px"
      title={
        <>
          <ModalTitle>
            {t(HYBRID_MAIL_ROOM.SEND_LETTERS_TEXT.key, HYBRID_MAIL_ROOM.SEND_LETTERS_TEXT.value)}
          </ModalTitle>
          <ModalDescription>
            {t(
              HYBRID_MAIL_ROOM.HYBRID_MAIL_TITLE_DES.key,
              HYBRID_MAIL_ROOM.HYBRID_MAIL_TITLE_DES.value,
            )}
          </ModalDescription>
        </>
      }
    >
      <ModalContent isHybrid={true}>
        <div>
          <Label>
            {t(HYBRID_MAIL_ROOM.HYBRID_JOB_NAME.key, HYBRID_MAIL_ROOM.HYBRID_JOB_NAME.value)}{' '}
            <Required>*</Required>
          </Label>
          <Input
            placeholder={t(
              HYBRID_MAIL_ROOM.JOB_NAME_PLACEHOLDER.key,
              HYBRID_MAIL_ROOM.JOB_NAME_PLACEHOLDER.value,
            )}
            value={jobName}
            onChange={e => setJobName(e.target.value)}
            disabled={isUploading}
            size="large"
          />
        </div>
        <FormRow>
          <FormField isHybrid={true}>
            <Label htmlFor="split-criteria">
              {t(
                HYBRID_MAIL_ROOM.SPLIT_CRITERIA_LABEL.key,
                HYBRID_MAIL_ROOM.SPLIT_CRITERIA_LABEL.value,
              )}
            </Label>
            <StyledSelect
              id="split-criteria"
              value={splitCriteria}
              onChange={handleSplitCriteriaChange}
              disabled={isUploading}
            >
              <Option value="address">
                {t(
                  HYBRID_MAIL_ROOM.SPLIT_CRITERIA_ADDRESS.key,
                  HYBRID_MAIL_ROOM.SPLIT_CRITERIA_ADDRESS.value,
                )}
              </Option>
              <Option value="pageCount">
                {t(
                  HYBRID_MAIL_ROOM.SPLIT_CRITERIA_PAGE.key,
                  HYBRID_MAIL_ROOM.SPLIT_CRITERIA_PAGE.value,
                )}
              </Option>
            </StyledSelect>
          </FormField>

          <FormField isHybrid={true}>
            <Label htmlFor="page-count">
              {t(HYBRID_MAIL_ROOM.PAGE_COUNT_LABEL.key, HYBRID_MAIL_ROOM.PAGE_COUNT_LABEL.value)}{' '}
              {splitCriteria === 'pageCount' && <Required>*</Required>}
            </Label>
            <Input
              id="page-count"
              type="number"
              min={1}
              placeholder={t(
                HYBRID_MAIL_ROOM.PAGE_COUNT_PLACEHOLDER.key,
                HYBRID_MAIL_ROOM.PAGE_COUNT_PLACEHOLDER.value,
              )}
              value={pageCount}
              onChange={e => setPageCount(e.target.value)}
              disabled={splitCriteria !== 'pageCount' || isUploading}
              size="large"
            />
          </FormField>
        </FormRow>

        <div>
          <DragDropZone
            onDragOver={handleDragOver}
            onDragLeave={handleDragLeave}
            onDrop={handleDrop}
            $isDragging={isDragging}
          >
            <FileInput
              type="file"
              id="file-upload"
              accept=".pdf,.docx"
              onChange={handleFileSelect}
            />

            <UploadContent>
              <UploadCenter>
                <IconWrapper>
                  {!isUploading ? (
                    <Icon type="cloud-upload" style={{ fontSize: 48, color: '#9CA3AF' }} />
                  ) : (
                    <CloudIconWrapper $isUploading={isUploading}>
                      <Icon type="cloud-upload" style={{ fontSize: 48, color: '#3B82F6' }} />
                    </CloudIconWrapper>
                  )}
                </IconWrapper>

                <TextWrapper>
                  <UploadTitle>
                    {t(HYBRID_MAIL_ROOM.DRAG_AND_DROP.key, HYBRID_MAIL_ROOM.DRAG_AND_DROP.value)}
                  </UploadTitle>
                  <UploadText>
                    {t(
                      HYBRID_MAIL_ROOM.TO_SEND_LETTERS.key,
                      HYBRID_MAIL_ROOM.TO_SEND_LETTERS.value,
                    )}
                  </UploadText>
                  <UploadHint>
                    {t(
                      HYBRID_MAIL_ROOM.SUPPORTED_FORMATS.key,
                      HYBRID_MAIL_ROOM.SUPPORTED_FORMATS.value,
                    )}
                  </UploadHint>
                </TextWrapper>
              </UploadCenter>

              {uploadedFile && (
                <FileDisplay>
                  <FileItem>
                    <FileHeader>
                      <FileInfo>
                        <FileIconWrapper>
                          <Icon type="file-text" style={{ fontSize: 20, color: 'white' }} />
                        </FileIconWrapper>
                        <FileDetails>
                          <FileName>{uploadedFile.name}</FileName>
                          <FileSize>{(uploadedFile.size / 1024).toFixed(1)} KB</FileSize>
                        </FileDetails>
                      </FileInfo>
                      <RemoveButton
                        onClick={e => {
                          e.preventDefault();
                          e.stopPropagation();
                          removeFile();
                        }}
                      >
                        <Icon type="close" style={{ fontSize: 18, color: '#EF4444' }} />
                      </RemoveButton>
                    </FileHeader>
                    {isUploading && (
                      <ProgressSection>
                        <ProgressHeader>
                          <ProgressLabel>
                            <CloudIconWrapper $isUploading={isUploading}>
                              {uploadProgress === 100 ? (
                                <Icon
                                  type="check-circle"
                                  style={{ fontSize: 16, color: '#10B981' }}
                                />
                              ) : (
                                <Icon
                                  type="cloud-upload"
                                  style={{ fontSize: 16, color: '#3B82F6' }}
                                />
                              )}
                            </CloudIconWrapper>
                            {uploadProgress === 100
                              ? t(
                                  HYBRID_MAIL_ROOM.UPLOADED_TO_CLOUD.key,
                                  HYBRID_MAIL_ROOM.UPLOADED_TO_CLOUD.value,
                                )
                              : t(
                                  HYBRID_MAIL_ROOM.UPLOADING_TO_CLOUD.key,
                                  HYBRID_MAIL_ROOM.UPLOADING_TO_CLOUD.value,
                                )}
                          </ProgressLabel>
                          <StatusBadge $complete={uploadProgress === 100}>
                            {uploadProgress === 100 ? (
                              <>
                                <Icon type="check-circle" style={{ fontSize: 12 }} />
                                Complete
                              </>
                            ) : (
                              `${uploadProgress}%`
                            )}
                          </StatusBadge>
                        </ProgressHeader>
                        <StyledProgress
                          percent={uploadProgress}
                          showInfo={false}
                          strokeWidth={6}
                          status={uploadProgress === 100 ? 'success' : 'active'}
                        />
                      </ProgressSection>
                    )}
                    {hasUploadError && !isUploading && (
                      <div
                        style={{
                          color: '#EF4444',
                          fontSize: '12px',
                          marginTop: '8px',
                          textAlign: 'center',
                        }}
                      >
                        <Icon type="warning" style={{ marginRight: '4px' }} />
                        Upload failed at {uploadProgress.toFixed(0)}%. Please check your connection
                        and try again.
                      </div>
                    )}
                  </FileItem>
                </FileDisplay>
              )}
            </UploadContent>
          </DragDropZone>
        </div>
        <Divider style={{margin:'4px 0px'}}>Or</Divider>
        <div style={{display:'flex', justifyContent:'space-around'}}>
            <QueueButton
              isDisabled={isBatchQueueButtonDisabled || enableProceed}
              onClick={() => { setShowQueue(true); setHybridModal(false); }}
            >
              {t(
                HYBRID_MAIL_ROOM.CREATE_JOB_FROM_QUEUE.key,
                HYBRID_MAIL_ROOM.CREATE_JOB_FROM_QUEUE.value,
              )}
            </QueueButton>
        </div>
        <ButtonGroup>
          <CancelButton
            onClick={() => {
              if (isUploading && cancelTokenSource.current) {
                cancelTokenSource.current.cancel('Upload cancelled by user.');
                cancelTokenSource.current = null;
              }
              setJobName('');
              setHybridModal(false);
              handleSplitCriteriaChange('address');
            }}
          >
            {t(HYBRID_MAIL_ROOM.CANCEL_BUTTON.key, HYBRID_MAIL_ROOM.CANCEL_BUTTON.value)}
          </CancelButton>
          <PrimaryButton
            type="primary"
            onClick={handleSubmit}
            disabled={isUploading || !enableProceed}
            loading={isUploading}
          >
            {hasUploadError
              ? t(HYBRID_MAIL_ROOM.RETRY_BUTTON.key, HYBRID_MAIL_ROOM.RETRY_BUTTON.value)
              : t(HYBRID_MAIL_ROOM.PROCEED_BUTTON.key, HYBRID_MAIL_ROOM.PROCEED_BUTTON.value)}
          </PrimaryButton>
        </ButtonGroup>
      </ModalContent>
      
    </StyledModal>
    {showQueue && <HybridQueue jobName={jobName} closeModals={closeModals} setHybridInfo={setHybridInfo}
setCurrentPage={setCurrentPage} />}
    </>
  );
};

export default withTranslation(NAMESPACES)(SendLettersModal);
